import Alert from "@material-ui/lab/Alert";
import { FC, useEffect, useState } from "react";
import {
  FormGroupContextProvider,
  FormWithRedirect,
  minValue,
  NumberInput,
  required,
  Title,
  useNotify,
  useUpdate,
} from "react-admin";

import CustomCard from "../../components/CustomCard";
import CustomToolbar from "../../components/CustomToolbar";
import FormWrapper from "../../components/FormWrapper";
import Loader from "../../components/Loader";
import Spacing from "../../components/Spacing";
import useDisabledOnLoading from "../../hooks/useDisabledOnLoading";
import { firestore } from "../../init/firebase";
import { FormGroupNames } from "../../types/reactAdmin.types";
import { AppResource } from "../../types/resource.types";
import { applyUpdateTimestamp } from "../../utils/timestamp";

const CashCancelation: FC<any> = (props) => {
  const [update, { loading }] = useUpdate();
  const notify = useNotify();

  const [settings, setSettings] = useState<any>({});
  const [fetchingSettingsError, setFetchingSettingsError] = useState<string | null>(null);
  const [fetchingSettingsLoading, setFetchingSettingsLoading] = useState(true);

  const { disabledStyles } = useDisabledOnLoading(loading);

  const handleSubmit = (data: any) => {
    update(AppResource.settings, AppResource.general, applyUpdateTimestamp(data), settings, {
      onSuccess() {
        notify("Settings has been updated", "success");
      },
      onFailure(ex: any) {
        console.log(ex.message);
        notify("Error on updating settings", "error");
      },
    });
  };

  useEffect(() => {
    setFetchingSettingsLoading(true);
    firestore
      .collection(AppResource.settings)
      .doc("general")
      .get()
      .then((doc) => {
        setSettings(doc.data());
        setFetchingSettingsLoading(false);
        setFetchingSettingsError(null);
      })
      .catch(() => {
        setFetchingSettingsLoading(false);
        setFetchingSettingsError("Couldn't fetch settings!");
      });
  }, []);

  return (
    <Loader loading={fetchingSettingsLoading} size={24}>
      {fetchingSettingsError ? (
        <Alert severity="error">{fetchingSettingsError}</Alert>
      ) : (
        <FormWrapper>
          <Title title="Settings" />
          <FormGroupContextProvider name={FormGroupNames.settings}>
            <FormWithRedirect
              {...props}
              record={settings}
              save={handleSubmit}
              render={(formProps) => {
                return (
                  <form style={disabledStyles}>
                    <CustomCard title="Cash Cancelation Policies" withMarginBottom={false}>
                      <Spacing>
                        <NumberInput
                          source="suspensionDays"
                          label="Suspension days (Days)"
                          validate={[required(), minValue(1)]}
                          variant="outlined"
                          fullWidth
                        />
                        <NumberInput
                          source="maxCancellationCount"
                          label="Max cancellation count"
                          validate={[required(), minValue(1)]}
                          variant="outlined"
                          fullWidth
                        />
                      </Spacing>
                    </CustomCard>

                    <CustomToolbar {...formProps} formName={FormGroupNames.settings} customErrors={{}} />
                  </form>
                );
              }}
            />
          </FormGroupContextProvider>
        </FormWrapper>
      )}
    </Loader>
  );
};

export default CashCancelation;
